import { render, staticRenderFns } from "./PersonalizePackaging.vue?vue&type=template&id=4df0de9e&scoped=true"
import script from "./PersonalizePackaging.vue?vue&type=script&lang=js"
export * from "./PersonalizePackaging.vue?vue&type=script&lang=js"
import style0 from "./PersonalizePackaging.vue?vue&type=style&index=0&id=4df0de9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df0de9e",
  null
  
)

export default component.exports